import {
  type ReactNode,
  createContext,
  useState,
  useContext,
  type Dispatch,
  type SetStateAction,
} from "react";
import type { SubscriptionStatus } from "~/models/SubscriptionStatus";

type RcContextType = [
  SubscriptionStatus | null,
  Dispatch<SetStateAction<SubscriptionStatus | null>>,
];

const RcContext = createContext<RcContextType | undefined>(undefined);

function RcProvider({
  children,
  status,
}: {
  children: ReactNode;
  status: SubscriptionStatus | null;
}) {
  const [subscriptionStatus, setSubscriptionStatus] =
    useState<SubscriptionStatus | null>(status ?? null);
  return (
    <RcContext.Provider value={[subscriptionStatus, setSubscriptionStatus]}>
      {children}
    </RcContext.Provider>
  );
}

function useRcStatus() {
  const context = useContext(RcContext);
  if (context === undefined) {
    throw new Error("useRcStatus must be used within a RcProvider");
  }
  return context;
}

export { RcProvider, RcContext, useRcStatus };
